import { render, staticRenderFns } from "./BxNotification.vue?vue&type=template&id=a5dabb9e&"
import script from "./BxNotification.vue?vue&type=script&lang=js&"
export * from "./BxNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports